import session from "../config/session";

class BaseService {
  constructor() {}

  getToken() {
    return session.token;
  }
}

/**
var Service = {
    define:function(serviceProps) {

        var newService = _.extend(serviceProps, {

            getToken:function() {
                return UserStore.getToken()
            }

        });

        return newService;
    }
} **/

export default BaseService;
